export const getFormData = (obj, formData?: FormData, key?) => {
  formData = formData ?? new FormData();

  if (obj === undefined || obj === null) {
    return formData;
  } else if (Array.isArray(obj) && obj.length > 0) {
    obj.forEach((value, index) => {
      getFormData(value, formData, `${key ?? ''}[${index}]`);
    });
  } else if (
    obj === Object(obj) &&
    !Array.isArray(obj) &&
    !(obj instanceof File)
  ) {
    Object.keys(obj).forEach((objKey) => {
      const value = obj[objKey];
      getFormData(value, formData, key ? `${key}[${objKey}]` : objKey);
    });
  } else {
    formData.append(key, obj);
  }

  return formData;
};
